import styled from "@emotion/styled"
import { Link, NavLink } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';

export const Header = styled('header')`
	box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
	width: 100vw;
	height: auto;
`;

export const LogoStyle = styled('img')`
	width: 5.625rem;
	height: auto;
`;

export const LogoText = styled(Link)`
	padding: 1rem;
	font-size: 2.3rem;
	font-weight: 500;
	letter-spacing: 0;
	text-transform: uppercase;
`;

export const NavLinkStyled = styled(NavLink)`
	padding: 1.6rem;
	margin-left: 2rem;
	font-size: 1.92rem;
	font-weight: 500;
	letter-spacing: 0;
	color: #50aeb0 !important;

	@media screen and (max-width: 991px) {
		margin-left: 1rem;
		font-size: 1.7rem;
	}
	@media screen and (max-width: 767px) {
		margin-left: 0;
		text-align: center;
	}
`;

export const NavGroup = styled(Navbar)`
	.navbar-brand {
		margin-right: 0;
	}
	@media screen and (max-width: 767px) {
		button {
			margin-left: 20.5px;
		}
	}
`;